import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTrigger } from '../ui/dialog';
import { Button } from '../ui/button';
import StripeForm from '@/app/verify/StripeForm';
import { Flex, Text } from '@radix-ui/themes';

interface Props {
  refresh: () => void;
}

const CreditCardPopup = ({ refresh }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="text-sm px-2" variant="ghost">
          Add Payment Method
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[85vh] overflow-y-auto">
        <Flex direction="column" className="space-y-6">
          <Text className="text-xl font-medium">Add Credit Card</Text>
          <StripeForm onNext={() => {
            setOpen(false)
            refresh();
          }} allowLaterSubmission={false} />
        </Flex>
      </DialogContent>
    </Dialog>
  );
}

export default CreditCardPopup
